import { render } from "./PublicFirstTimer.vue?vue&type=template&id=32b7b338&scoped=true"
import script from "./PublicFirstTimer.vue?vue&type=script&lang=js"
export * from "./PublicFirstTimer.vue?vue&type=script&lang=js"

import "./PublicFirstTimer.vue?vue&type=style&index=0&id=32b7b338&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b7b338"]])

export default __exports__